var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_12407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2997 14.359H3.64353V15.8974H16.2997V14.359ZM15.6896 6.79842L16.0434 9.92092L17.5721 9.7478L17.2184 6.62524L15.6896 6.79842ZM3.89979 9.92092L4.25351 6.79842L2.72482 6.62524L2.37111 9.7478L3.89979 9.92092ZM2.81986 12.4264C3.41951 11.7205 3.79492 10.8467 3.89979 9.92092L2.37111 9.7478C2.30019 10.3738 2.04667 10.9603 1.64742 11.4302L2.81986 12.4264ZM16.0434 9.92092C16.1483 10.8467 16.5237 11.7205 17.1233 12.4264L18.2958 11.4302C17.8965 10.9603 17.643 10.3738 17.5721 9.7478L16.0434 9.92092ZM3.64353 14.359C2.73399 14.359 2.15545 13.2083 2.81986 12.4264L1.64742 11.4302C0.192011 13.1433 1.33393 15.8974 3.64353 15.8974V14.359ZM16.2997 15.8974C18.6092 15.8974 19.7512 13.1433 18.2958 11.4302L17.1233 12.4264C17.7877 13.2083 17.2092 14.359 16.2997 14.359V15.8974ZM17.2184 6.62524C16.7925 2.86639 13.6925 0 9.97159 0V1.53846C12.8744 1.53846 15.3479 3.78152 15.6896 6.79842L17.2184 6.62524ZM4.25351 6.79842C4.59526 3.78152 7.06879 1.53846 9.97159 1.53846V0C6.25069 0 3.15063 2.86639 2.72482 6.62524L4.25351 6.79842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7691 17.4496C13.9182 17.0517 13.7166 16.6084 13.3187 16.4593C12.9209 16.3102 12.4776 16.5118 12.3285 16.9097L13.7691 17.4496ZM7.61523 16.9097C7.46615 16.5118 7.02279 16.3102 6.62498 16.4593C6.22716 16.6084 6.02553 17.0517 6.17462 17.4496L7.61523 16.9097ZM12.3285 16.9097C11.9975 17.7928 11.0843 18.4617 9.97185 18.4617V20.0001C11.7006 20.0001 13.2043 18.9565 13.7691 17.4496L12.3285 16.9097ZM9.97185 18.4617C8.85944 18.4617 7.94621 17.7928 7.61523 16.9097L6.17462 17.4496C6.73939 18.9565 8.24313 20.0001 9.97185 20.0001V18.4617Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_12407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell .78884c7ccdc233e29301bbc1940f0a37.svg";
export { ForwardRef as ReactComponent };